<template>
  <div>
    <WorksLoader v-if="!$route.params.slug" :payload="{fullView: true}"></WorksLoader>
    <Footer />
  </div>
</template>

<script>
import WorksLoader from "@components/worksLoader/WorksLoader";
import Footer from "@components/global/Footer";
import { mapGetters } from "vuex";

export default {
  components: {
    WorksLoader,
    Footer
  },
  metaInfo() {
    return {
      title: this.getTitle(),
      titleTemplate: '%s | Dinamo Digitale',
      meta: [
        { name: 'og:title', content: this.getTitle() + ' | Dinamo Digitale'},
        { name: 'twitter:title', content: this.getTitle() + ' | Dinamo Digitale'},
        { name: 'description', content: this.getAbstract()},
        { name: 'og:description', content: this.getAbstract()},
        { name: 'twitter:description', content: this.getAbstract()},
        { name: 'keywords', content: this.getDescription()},
        { name: 'og:type', content: 'website'},
        { name: 'og:url', content: window.location.href},
        { name: 'og:image', content: this.getPageImage()},
        { name: 'twitter:image', content: this.getPageImage()},
      ]
    }
  },
  data() {
    return {
      resourceUrl: process.env.VUE_APP_RESOURCES,
      defaultTitle: 'Portfolio',
      defaultDescription: 'Scopri i nostri lavori',
      defaultKeywords: 'consulenza design marketing sviluppo integrazione'
    };
  },
  mounted() {
    this.getPage('cosa');
  },
  methods: {
    getPage(slug) {
      this.$store.dispatch("getPage", slug);
    },
    getTitle() {
      if (this.page && this.page.title) {
        return this.page.title
      }
      return this.defaultTitle
    },
    getAbstract() {
      if (this.page && this.page.abstract) {
        return this.page.abstract
      }
      return this.defaultDescription
    },
    getDescription() {
      if (this.page && this.page.description) {
        return this.page.description
      }
      return this.defaultKeywords
    },
    getPageImage() {
      if (this.page && this.page.mainImage && this.page.mainImage.file && this.page.mainImage.file.path) {
        return this.resourceUrl + this.page.mainImage.file.path
      } else if (this.page && this.page.mobileImage && this.page.mobileImage.file && this.page.mobileImage.file.path) {
        return this.resourceUrl + this.page.mobileImage.file.path
      }
      return undefined
    }
  },
  computed: {
    ...mapGetters({
      page: "getPage"
    })
  }
};
</script>